// src/components/ButtonExBase.tsx
import { Button, useTheme } from "@mui/material";
import { toPromise } from "@xylabs/promise";
import { useUserEvents } from "@xylabs/react-pixel";
import {
  BusyCircularProgress,
  BusyLinearProgress,
  mergeBoxlikeStyles
} from "@xylabs/react-shared";
import { isString } from "@xylabs/typeof";
import { jsx, jsxs } from "react/jsx-runtime";
var ButtonExBase = ({
  ref,
  funnel,
  intent,
  target,
  placement,
  disableUserEvents,
  href,
  ...props
}) => {
  const theme = useTheme();
  const userEvents = useUserEvents();
  const {
    busy,
    busyVariant = "linear",
    busyOpacity,
    onClick,
    children,
    ...rootProps
  } = mergeBoxlikeStyles(theme, props);
  const localOnClick = (event) => {
    if (busy) {
      event.preventDefault();
    } else {
      const elementName = props["aria-label"] ?? event.currentTarget.textContent;
      const windowToNavigate = () => isString(target) && isString(href) ? window.open("", target) ?? globalThis : globalThis;
      const callOnClickAndFollowHref = (windowToNav = windowToNavigate()) => {
        onClick?.(event);
        if (isString(href)) {
          windowToNav.location.href = href;
        }
      };
      if (!disableUserEvents && userEvents) {
        event.preventDefault();
        const windowToNav = windowToNavigate();
        if (isString(href)) {
          toPromise(userEvents.userClick({
            elementName,
            intent,
            funnel,
            placement
          })).then(() => {
            callOnClickAndFollowHref(windowToNav);
          }).catch((ex) => {
            console.error("User event failed", elementName, funnel, placement, ex);
            callOnClickAndFollowHref(windowToNav);
          });
        }
        onClick?.(event);
      } else {
        callOnClickAndFollowHref();
      }
    }
  };
  return /* @__PURE__ */ jsxs(Button, { ref, href, onClick: localOnClick, target, ...rootProps, children: [
    busy && busyVariant === "linear" ? /* @__PURE__ */ jsx(BusyLinearProgress, { rounded: true, opacity: busyOpacity ?? 0 }) : null,
    busy && busyVariant === "circular" ? /* @__PURE__ */ jsx(BusyCircularProgress, { rounded: true, size: 24, opacity: busyOpacity ?? 0.5 }) : null,
    children
  ] });
};
ButtonExBase.displayName = "ButtonExBaseXYLabs";

// src/components/ButtonExTo.tsx
import { isDefined } from "@xylabs/typeof";
import { useNavigate } from "react-router-dom";
import { jsx as jsx2 } from "react/jsx-runtime";
var ButtonToEx = ({
  ref,
  to,
  toOptions,
  onClick,
  ...props
}) => {
  const navigate = useNavigate();
  const localOnClick = (event) => {
    onClick?.(event);
    if (isDefined(to)) {
      void navigate(to, toOptions);
    }
  };
  return /* @__PURE__ */ jsx2(ButtonExBase, { ref, onClick: localOnClick, ...props });
};
ButtonToEx.displayName = "ButtonToExXYLabs";

// src/components/ButtonEx.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var ButtonEx = ({ ref, ...props }) => {
  if (props.to === void 0) {
    return /* @__PURE__ */ jsx3(ButtonExBase, { ...props });
  } else {
    const { to, ...additionalProps } = props;
    return /* @__PURE__ */ jsx3(ButtonToEx, { to, ref, ...additionalProps });
  }
};
ButtonEx.displayName = "ButtonExXYLabs";

// src/components/ButtonExProps.tsx
import { isDefined as isDefined2, isString as isString2 } from "@xylabs/typeof";
var asButtonHrefOrToProps = ({
  href,
  to,
  toOptions
}) => {
  if (isString2(href) && (isDefined2(to) || isDefined2(toOptions))) {
    throw new Error("ButtonExProps: cannot have both href and to");
  }
  return isString2(href) ? { href } : isDefined2(to) ? { to, toOptions } : {};
};
export {
  ButtonEx,
  asButtonHrefOrToProps
};
//# sourceMappingURL=index.mjs.map